// Dependencies imports
import React, { useState, useEffect, useRef } from "react";
import { API, Auth } from "aws-amplify";
import ClockGray from "../../../assets/svgjs/ClockGray";
import Cviewstyle from "./courseView.module.scss";
import DialogBox from "./Dialogbox";
import "./courseView.scss";
import UserHeader from "../../Header/UserHeader/UserHeader";
import { Constants } from "../../../config/constants";
import config from "../../../config/aws-exports";
import CloseIcon from "@material-ui/icons/Close";
import { FormDropdown, Tab } from "semantic-ui-react";

import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import moment from "moment";
import { FaBars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCookie } from "react-use-cookie";
import CoursePlayer from "./CoursePlayer";
import { awsSignIn, authData, awsSignOut } from "../../../redux/auth/authSlice";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import addpluse from "../../../assets/images/add.png";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

// Local imports
import References from "./References";
import RecordSession from "./RecordSession";
import LiveSession from "../LiveSession";
import AddRecordings from "./AddRecordings";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// Style imports
import Caviewstyle from "../../../components/Programs/CourseCreation/courseCreation.module.scss";
import Assignment from "./Assignment/Assignment";
import ObjectPopUp from "../../../components/Programs/CourseCreation/AddObjects";
import AssignmentAndAssessment from "../../../components/AssignmentAndAssessment/AssignmentAndAssessment";
import {
  Button,
  Input,
  Fade,
  Backdrop,
  Modal,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  TextareaAutosize,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ReactPlayer from "react-player";
import useWindowDimensions from "../../../modules/Window/Window";
import QuizIc from "../../../assets/svgjs/Quiz";
import PdfIcon from "../../../assets/svgjs/Pdf";
import IconButton from "@material-ui/core/IconButton";
import { Close } from "@mui/icons-material";
import Done from "../../../assets/svgjs/Done";
import RatingStar from "../../../modules/Rating/Rating";

import Video from "../../../assets/svgjs/Video";
import Review from "../../../assets/svgjs/Review";
import Html from "../../../assets/svgjs/Html";
import Audio from "../../../assets/svg/Audio.svg";

import Skeleton from "@material-ui/lab/Skeleton";
import Assessment from "./Assessment/Assessment";
import swal from "sweetalert";
import axios from "axios";
import AddRecording from "./AddRecordings";
import RegexTextField from "../CourseCreation/RegexTextField";
import editIcon from "../../../assets/images/edit.png";
import deleteIcon from "../../../assets/images/delete.png";
import eyeIcon from "../../../assets/images/eye.png";
import produce from "immer";
import EditNTitleAndEditUTitle from "./EditNTitleAndEditUTitle";
import YouTubeVideo from "../../../assets/svgjs/YouTubeVideo";
import { element } from "prop-types";
import Vimeo from "../../../assets/svgjs/Vimeo";

import Ann from "../Announcement.module.scss";
import { ReactComponent as Delete } from "../../../assets/svg/delete_black_24dp.svg";
import { ReactComponent as Edit } from "../../../assets/svg/edit_black_24dp.svg";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingTop: "20px",
    overflowY: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    borderRadius: "10px",
  },
  paper: {
    "& .MuiDialog-paperWidthSm": {
      minWidth: "1100px",
    },
  },
  livepaper: {
    "& .MuiDialog-paperWidthSm": {
      minWidth: "860px",
      padding: "10px 30px",
    },
  },
  tooltipFull: {
    fontSize: 30,
  },
  bottomIcons: {
    color: "#000",
    "&:hover": {
      color: "#777",
    },
  },
  volumeButton: {
    color: "#000",
    fontSize: 40,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#777",
      transform: "scale(1.03)",
      transitionTimingFunction: "cubic-bezier(0.1, 0.1, 0.25, 1)",
    },
  },
  volumeButtonExit: {
    color: "lightgray",
    fontSize: 40,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#777",
      transform: "scale(1.03)",
      transitionTimingFunction: "cubic-bezier(0.1, 0.1, 0.25, 1)",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
const header = {
  color: "white",
  fontFamily: "nunito",
  fontSize: "15px",
  fontWeight: "400px",
};

const programnames = {
  color: config.main_color_1,
  fontFamily: "nunito",
  fontSize: "16px",
  fontWeight: "500px",
  width: "20%",
};

const programtype = {
  color: "#6a6a6a !important",
  fontSize: "14px",
  fontWeight: "400px",
  fontFamily: "nunito",
  paddingBotton: "10px",
  width: "60%",
};
const programetype = {
  color: "#6a6a6a !important",
  fontSize: "14px",
  fontWeight: "400px",
  fontFamily: "nunito",
  paddingBotton: "10px",
  width: "10%",
};
export default function CourseView({ handleToggleSidebar }) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const onlyAlphanumericRegex = /[^0-9]/gi;
  //const [course, setCourse] = useState({tdescription:"Course Description"});
  const [courseDetails, setCourseDetails] = useState({
    tdescription: "Course Description",
  });
  const [tableData, setTableData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [objectData, setObjectData] = useState({});
  const [oIndex, setOIndex] = useState(0);
  const [curObject, setcurObject] = useState({});
  const curObRef = useRef({});
  const [assignment, setAssignment] = useState(false);
  const [assignmentLoad, setAssignmentLoad] = useState(true);
  const [cNugget, setcNugget] = useState({});
  const [errors, setErrors] = useState({ uval: false, nval: false });
  //const [objects, setObjects] = useState([]);
  const [nuggets, setNuggets] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showPage, setShowPage] = useState(true);
  const [summative, setSummative] = useState(false);
  const [sumScore, setSumScore] = useState(false);
  const [objOpen, setObjOpen] = useState(false);
  const [type, setType] = useState("");
  const [unitIndex, setUnitIndex] = useState(0);

  const [addtype, setAddType] = useState("");
  const [etype, setEType] = useState("");
  const [editsessiondata, setEditSessionData] = useState({});
  const { height, width } = useWindowDimensions();

  const [live, setLive] = useState([]);
  const [liveLoad, setLiveLoad] = useState(true);
  const [liveopen, setLiveOpen] = useState(false);
  const live_url = useRef("");
  const [qisLoading, setQIsLoading] = useState(false);
  const [sMiniScore, setSMiniScore] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [miniScore, setMiniScore] = useState(0);
  const [enable, setEnable] = useState(false);
  const [editObj, setEditObj] = useState({
    editbtn: true,
    meditmode: false,
    oeditmode: false,
    nuggetchanges: false,
    topicimgchanges: false,
    overViewEdit: false,
    weekEdit: false,
    nTitleEdit: false,
    uTitleEdit: false,
    imgEdit: false,
    titleEdit: false,
    objectView: false,
    editSemester: false,
  });
  const [nTitleIndexAndUTitleIndex, setNTitleIndexAndUTitleIndex] = useState({
    nIdx: 0,
    uIdx: 0,
  });
  const [editOpen, setEditOpen] = useState(false);
  const [selectedObj, setSelectedObj] = useState({});
  const redux = useRef({});
  const [folder, setFolder] = useState();
  const refnuggetValue = useRef("");
  const refnuggetindex = useRef("");
  const [nopen, setNopen] = useState();
  const [isnloaded, setIsnloaded] = useState(false);
  const [istLoading, setIstLoading] = useState(false);
  const [mainCourse, setMainCourse] = useState({});
  const [editType, setEditType] = useState("");
  let navigate = useNavigate();
  let userDetails = useSelector(authData);
  const refselectedCourseFile = useRef();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [loading, setLoading] = useState(true);
  const [openSession, setOpenSession] = useState(false);
  const [obj, setObj] = useState();
  const [deleteEventData, setDeleteEventData] = useState();

  let lcourseDetails = userDetails.curprg;
  const scrollRef = useRef();
  const accRef = useRef();

  const handleChange = (panel) => (event, isExpanded) => {
    scrollRef.current.scrollTo(
      0,
      document.getElementById("acc" + panel).offsetTop -
        scrollRef.current.scrollHeight +
        1500
    );
    setExpanded(isExpanded ? panel : false);
  };
  const handleEditOpen = () => {
    setEditOpen(true);
    setEditObj({ ...editObj, nTitleEdit: true });
  };

  const handleEditClose = () => {
    setEditOpen(false);
  };
  useEffect(() => {
    getCourseDetails();
    //getCourseVideo();
    getEvents();
    breadcrumb();
    reduxRestore();
  }, []);
  function viewLive(item) {
    setObj(item);
    handleSessionOpen();
  }
  const handleSessionOpen = () => {
    setOpenSession(true);
  };
  async function getCourseDetails() {
    setIsLoading(true);
    const bodyParam = {
      body: {
        btopicid: lcourseDetails.btid,
        oid: config.aws_org_id,
        topicid: lcourseDetails.tid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const courseDetails = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_COURSE_DETAILS,
        bodyParam
      );

      courseDetails.topicimg = `https://${
        config.DOMAIN
      }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
        courseDetails.tid
      }.png`;
      console.log(JSON.stringify(courseDetails, null, 2));
      setNuggets(courseDetails.unit);
      setFolder(courseDetails.tid);
      console.log(courseDetails);

      if (userDetails.seminfo !== undefined) {
        if (userDetails.seminfo.tlabel !== undefined) {
          if (!courseDetails.semester && !courseDetails.tlabel) {
            courseDetails.semester = userDetails.seminfo.semester;
            courseDetails.tlabel = userDetails.seminfo.tlabel;

            var s = userDetails.seminfo.tlabel;
            var m = s.match(/([^\?]*)\Course-(\d*)/);
            if (m != undefined && m != null && m != "null") {
              var num = m[2],
                rest = m[1];
              courseDetails.coursenum = num;
            }
          }
        }
      }

      setCourseDetails(courseDetails);
      setMainCourse(courseDetails);
      setShowPage(courseDetails.tenabled);
      // setObjectData(temp);
      saveLocale(courseDetails);
      setIsLoading(false);
      let sdata = { ...redux.current };
      dispatch(awsSignIn(sdata));
    } catch (error) {
      console.error(error);
    }
  }
  function reduxRestore() {
    let sdata = { ...userDetails };
    redux.current = sdata;
  }
  async function getCourseVideo() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        cid: lcourseDetails.bcid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        // Constants.GET_COURSE_VIDEO,
        "/getcoursevideo",
        bodyParam
      );

      setLiveLoad(false);
      setLive(response.video);
    } catch (error) {
      console.error(error);
    }
  }
  function TablePaginationActions(props) {
    const classes = useStyles();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
  const handleclickdelete = (item, index) => {
    swal({
      text: "Are you sure want to delete ?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        addEvent(item);
      }
    });
  };
  async function addEvent(item) {
    const bodyParam = {
      body: {
        eid: item.eid,
        rtype: "delete",
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        topicid: userDetails.btid,
        action: "clivesessions",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.ADD_EVENTS,
        bodyParam
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );

      // const users = response;
      swal({
        title: "Success",
        text: "Live Session Deleted successfully",
        icon: "success",
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          window.location.reload();
          handleClose();
        }
      });
    } catch (error) {
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          // setSpin(false);
        }
      });
      console.log("getUserError", error);
    }
    console.log("Mount");
  }
  async function validationcourse() {
    let tdur = 0,
      tobj = 0,
      tvid = 0,
      tdoc = 0,
      tsq = 0,
      tfq = 0,
      ndur = 0;
    let nug = [...nuggets];

    if (
      courseDetails.semester === undefined ||
      courseDetails.semester === "" ||
      courseDetails.semester.length === 0
    ) {
      swal("Oops!", "Course semester cannot be empty", "error");
      return;
    }
    if (courseDetails.ttitle == "" || courseDetails.ttitle.length === 0) {
      swal("Oops!", "Course title cannot be empty", "error");
      return;
    }
    if (
      courseDetails.tdescription == "" ||
      courseDetails.tdescription.length === 0
    ) {
      swal(
        "Oops!",
        "Course description cannot be empty in Overview section",
        "error"
      );
      return;
    }
    if (courseDetails.tduration == "" || courseDetails.tduration.length === 0) {
      swal("Oops!", "Course duration cannot be empty", "error");
      return;
    }
    if (courseDetails.tduration < 1) {
      swal("Oops!", "Course duration must be greater than 0", "error");
      return;
    }
    if (nuggets.length === 0) {
      swal("Oops!", "You need to add atleast 1 Module.", "error");
      return;
    }
    if (nuggets.length > 0) {
      for (let k = 0; k < nuggets.length; k++) {
        if (nuggets[k].nuggets.length > 0) {
          for (let j = 0; j < nuggets[k].nuggets.length; j++) {
            if (nuggets[k].nuggets[j].objects.length > 0) {
            } else {
              swal(
                "Oops!",
                "You need to add at least 1 Content in each Module",
                "error"
              );
              return;
            }
          }
        } else {
          swal(
            "Oops!",
            "You need to add at least 1 Module in each Unit",
            "error"
          );
          return;
        }
      }
    }
    nug = produce(nug, (v) => {
      for (let i = 0; i < v.length; i++) {
        ndur = 0;
        for (let k = 0; k < v[i].nuggets.length; k++) {
          for (let o = 0; o < v[i].nuggets[k].objects.length; o++) {
            tobj++;
            ndur = ndur + Number(v[i].nuggets[k].objects[o].oduration);
            tdur = tdur + Number(v[i].nuggets[k].objects[o].oduration);
            if (
              v[i].nuggets[k].objects[o].otype == "video" ||
              v[i].nuggets[k].objects[o].otype == "audio"
            ) {
              tvid = tvid + 1;
            } else if (
              v[i].nuggets[k].objects[o].otype == "quiz" &&
              v[i].nuggets[k].objects[o].qtype == 1
            ) {
              tsq = tsq + 1;
            } else if (
              v[i].nuggets[k].objects[o].otype == "quiz" &&
              v[i].nuggets[k].objects[o].qtype != 1
            ) {
              tfq = tfq + 1;
            } else {
              tdoc = tdoc + 1;
            }
            if (
              v[i].nuggets[k].objects[o].otype == "interactivity" ||
              v[i].nuggets[k].objects[o].otype == "Interactivity"
            ) {
              v[i].nuggets[k].objects[o].ltype = "zp";
            }
            if (o == v[i].nuggets[k].objects.length - 1) {
              v[i].nuggets[k].nduration = ndur;
            }
            console.log(tdur);
          }
        }
      }
    });

    console.log(nug);
    handleEditSave(tobj, tvid, tdoc, tsq, tfq, nug);
  }
  const handleEditSave = async (tobj, tvid, tdoc, tsq, tfq, nugs) => {
    // setNuggets(courseDetails.nuggets);
    setIstLoading(true);
    let topicjson = { ...courseDetails };
    // console.log("nugs" + JSON.stringify(nugs, null, 2));
    if (courseDetails !== undefined) {
      if (courseDetails.coursenum && courseDetails.semester) {
        topicjson.tlabel = `Semester-${courseDetails.semester},Course-${courseDetails.coursenum}`;
        topicjson.coursenum = courseDetails.coursenum;
      }
    }
    topicjson.unit = nugs;
    topicjson.tobj = tobj;
    topicjson.tvid = tvid;
    topicjson.tdoc = tdoc;
    topicjson.tsq = tsq;
    topicjson.tfq = tfq;
    topicjson = produce(topicjson, (v) => {
      for (let q = 0; q < v.unit.length; q++) {
        for (let j = 0; j < v.unit[q].nuggets.length; j++) {
          for (var a = 0; a < v.unit[q].nuggets[j].objects.length; a++) {
            delete v.unit[q].nuggets[j].objects[a].curl;
            delete v.unit[q].nuggets[j].objects[a].file;
          }
        }
      }
      delete v.Policy;
      delete v.Signature;
      delete v.KeyPairId;
      delete v.topicimg;
    });

    const jwttoken = (await Auth.currentSession()).idToken.jwtToken;
    const bodyParam = {
      body: {
        topicjsonchanges: false,
        nuggetchanges: true,
        bpid: userDetails.curprg.bpid,
        topicjson,
        topicimgchanges: editObj.topicimgchanges,
        oid: config.aws_org_id,
        eid: userDetails.eid,
        tid: topicjson.tid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: jwttoken,
      },
    };

    if (userDetails.curprg !== undefined) {
      if (userDetails.curprg.btid !== undefined) {
        bodyParam.body.pid = userDetails.curprg.pid;
        bodyParam.body.btid = userDetails.curprg.btid;
      } else {
        bodyParam.body.pid = userDetails.curprg.pid;
        //bodyParam.body.btid = userDetails.curprg.pid;
      }
    }

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/edittopic",
        bodyParam
      );
      console.log(JSON.stringify(bodyParam.body, null, 2));
      setIstLoading(false);
      window.location.reload();
    } catch (error) {
      console.log("getCategoryError", error);
    }
  };

  const getAssignmentDataPost = async (quizid) => {
    setQIsLoading(true);
    setSMiniScore(false);
    setAssignmentLoad(true);
    setMiniScore(0);
    const bodyParam = {
      body: {
        quizid: quizid,
        oid: config.aws_org_id,
        eid: userDetails.eid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_ASSIGNMENT_DATA,
        bodyParam
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );

      if (response.errorMessage !== undefined) {
        setAssignment(true);
      } else {
        if (response.score !== undefined) {
          setSMiniScore(true);
          setMiniScore(response.score);
        }
        setAssignment(false);
      }
      setQIsLoading(false);
      setAssignmentLoad(false);
      // return response;
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const enableDisablePost = async (status, nid, ids, idx) => {
    setIstLoading(true);
    const bodyParam = {
      body: {
        topicid: courseDetails.tid,
        oid: config.aws_org_id,
        btid: courseDetails.btid,
        nid,
        disable: !status,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    if (
      userDetails.curprg !== undefined &&
      userDetails.curprg.btid !== undefined
    ) {
      bodyParam.body.btid = userDetails.curprg.btid;
    }

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/enableNuggets",
        bodyParam
      );
      // console.log(response)

      nuggets[idx].nuggets[ids].nenabled = !status;
      setIstLoading(false);
      console.log(JSON.stringify(bodyParam, null, 2));
      // return response;
    } catch (error) {
      console.log("enableNuggetserre", error);
    }
  };
  // const renderSwitch = (param) => {
  //   if (param === "video") {
  //     return <Video className="video-size" cls1="cls-1--v" cls2="cls-2--v" />;
  //   } else if (param === "audio") {
  //     return <div className="audio"></div>;
  //   } else if (param === "quiz") {
  //     return <QuizIc className="quizAct" />;
  //   } else if (param === "html") {
  //     return (
  //       <Html
  //         className="video-size"
  //         cls1="cls-1--H"
  //         cls2="cls-2--H"
  //         cls3="cls-3--H"
  //       />
  //     );
  //   } else if (param === "interactivity") {
  //     return <Review className="video-size" cls1="cls-1--R" cls2="cls-2--R" />;
  //   } else if (param === "pdf") {
  //     return <PdfIcon className="pdfAct" />;
  //   } else if (param === "youtube") {
  //     return <YouTubeVideo />;
  //   }
  // };
  const renderSwitch = (param) => {
    if (param === "video") {
      return <Video className="video-size" cls1="cls-1--v" cls2="cls-2--v" />;
    } else if (param === "audio") {
      return <img src={Audio} style={{ height: "32px" }} alt="audio" />;
    } else if (param === "quiz") {
      return <QuizIc className="quizAct" />;
    } else if (param === "html") {
      return (
        <Html
          className="video-size"
          cls1="cls-1--H"
          cls2="cls-2--H"
          cls3="cls-3--H"
        />
      );
    } else if (param === "Interactivity") {
      return <Review className="video-size" cls1="cls-1--R" cls2="cls-2--R" />;
    } else if (param === "pdf") {
      return <PdfIcon className="pdfAct" />;
    } else if (param === "youtube") {
      return <YouTubeVideo />;
    } else if (param === "vimeo") {
      return <Vimeo color="#f18121" />;
    }
  };

  const saveLocale = (data) => {
    const expires = new Date().getTime() + 60 * 60 * 1000;
    setCookie("CloudFront-Expires", expires);
    setCookie("CloudFront-Policy", data.Policy);
    setCookie("CloudFront-Signature", data.Signature);
    setCookie("CloudFront-Key-Pair-Id", data.KeyPairId);
  };

  function renderObjectsext(objType) {
    switch (objType) {
      case "video":
        return "video/*";
      case "audio":
        return "audio/*";
      case "pdf":
        return ".pdf";
      case "html":
        return ".html";
      case "Interactivity":
        return ".html, application/zip, application/x-zip-compressed, .zip";
      case "interactivity":
        return ".html, application/zip, application/x-zip-compressed, .zip";
      case "quiz":
        return ".json";
      default:
        return null;
    }
  }

  const viewAddEditCurrentObject = (object, idx, oidx, ids, nugget) => {
    let obj = {};
    obj.otherdata = {
      title: object.otitle,
      desc: object.odescription,
      dur: object.oduration,
      file: object.file,
      files: "",
    };

    if (object.oduration !== undefined && object.oduration != "") {
      obj.otherdata.min = Math.floor((object.oduration % 3600) / 60);
      obj.otherdata.sec = Math.floor((object.oduration % 3600) % 60);
    }
    obj.sobject = object.otype;
    obj.otype = object.otype;
    obj.oid = object.oid;
    obj.seltype = true;
    obj.error1 = false;
    obj.afile = renderObjectsext(object.otype);
    obj.uindex = idx;
    obj.oindex = oidx;
    obj.nindex = ids;
    obj.unit = nugget.unitname;
    obj.ourl = object.ourl;
    obj.curl = object.curl;
    if (object.stype == "chtml") {
      obj.stype = object.stype;
    } else {
      obj.stype = object.otype;
    }

    if (object.otype === "quiz") {
      obj.qtype = object.qtype;
      obj.cutoff = object.cutoff;
    }
    if (object.otype === "youtube" || object.otype === "vimeo") {
      obj.otherdata.embeddedcode = object.embeddedcode;
    }
    setSelectedObj(obj);
    setOIndex(oidx);
    setcurObject(object);
    // setObjectData(object)
    // if (objects.otype === "quiz") {
    //   getAssignmentDataPost(object.oid);
    // }
    handleClickOpen("body");
    setEditObj({ ...editObj, objectView: true });
    setOpen(true);
  };

  function CourseStructure() {
    return (
      <div>
        {istLoading && (
          <Backdrop className={classes.backdrop} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Typography component="div" variant="h1">
          {isLoading ? <Skeleton /> : null}
        </Typography>
        <Typography component="div" variant="h1">
          {isLoading ? <Skeleton /> : null}
        </Typography>
        <Typography component="div" variant="h1">
          {isLoading ? <Skeleton /> : null}
        </Typography>
        <Typography component="div" variant="h1">
          {isLoading ? <Skeleton /> : null}
        </Typography>
        {/* <pre>{JSON.stringify(topics, null, 2)}</pre> */}

        {!isLoading && (
          <DialogBox
            type={type}
            nuggets={nuggets}
            setNuggets={setNuggets}
            nopen={nopen}
            setNopen={setNopen}
            setIsLoading={setIsLoading}
            courseDetails={courseDetails}
            setCourseDetails={setCourseDetails}
            errors={errors}
            setErrors={setErrors}
            unitIndex={unitIndex}
            setEditObj={setEditObj}
            editObj={editObj}
          />
        )}
        {editObj.nTitleEdit && (
          <EditNTitleAndEditUTitle
            open={editOpen}
            nuggets={nuggets}
            nTitleIndex={nTitleIndexAndUTitleIndex.nIdx}
            uTitleIndex={nTitleIndexAndUTitleIndex.uIdx}
            setNuggets={setNuggets}
            setEditObj={setEditObj}
            setEditOpen={setEditOpen}
            editObj={editObj}
            editType={editType}
          />
        )}
        {isLoading ? (
          <></>
        ) : (
          <div className={classes.root}>
            {nuggets.map((nugget, idx) => (
              <Accordion
                key={idx}
                expanded={expanded === `${idx}`}
                onChange={handleChange(`${idx}`)}
                ref={accRef}
                id={"acc" + idx}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <h2
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      minHeight: "34px",
                    }}
                    className="unit-hover"
                  >
                    <span>{nugget.unitname}</span>
                    <span className="unit-edit-icon">
                      <button
                        onClick={() => {
                          setEditType("Unit");
                          handleEditOpen();
                          setNTitleIndexAndUTitleIndex((currentTitle) =>
                            produce(currentTitle, (v) => {
                              v.nIdx = 0;
                              v.uIdx = idx;
                            })
                          );
                        }}
                        className="btn-reset btn-border"
                      >
                        <img
                          src={editIcon}
                          className="size"
                          alt="edit-delete"
                        />
                      </button>
                      <button
                        style={{
                          color: "white",
                          borderStyle: "groove",
                          borderColor: config.main_color_2,
                          height: "30px ",
                          lineHeight: "0px ",
                          width: "150px",
                          backgroundColor: config.main_color_2,
                          fontSize: "15px ",
                          borderRadius: "3px ",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          let filteredUnit = nuggets.filter(
                            (nug) => nug.uid !== nugget.uid
                          );
                          setNuggets(filteredUnit);
                          setEditObj({ ...editObj, meditmode: true });
                        }}
                      >
                        Remove unit
                      </button>
                    </span>
                  </h2>
                </AccordionSummary>
                {nugget.nuggets.map(
                  ({ nenabled, ntitle, nid, objects }, ids) => (
                    <React.Fragment key={ids + "sdfljkdfgkj"}>
                      <AccordionDetails
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: ".8rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: "30px",
                          }}
                        >
                          <h3
                            className="edit-icons"
                            style={{
                              padding: ".6rem 0 .6rem 2.5rem",
                              fontWeight: "600",
                              fontFamily: "sans-serif",
                              fontSize: "1.5rem",
                              color: "rgba(0,0,0,.75)",
                              flexBasis: "90%",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              minHeight: "30px",
                            }}
                          >
                            {ntitle.substring(0, 150) +
                              `${ntitle.length > 150 ? "..." : ""}`}
                            <div className="hide__edit-icon">
                              <span>
                                <button
                                  onClick={() => {
                                    handleEditOpen();
                                    setEditType("Module");
                                    setNTitleIndexAndUTitleIndex(
                                      (currentTitle) =>
                                        produce(currentTitle, (v) => {
                                          v.nIdx = ids;
                                          v.uIdx = idx;
                                        })
                                    );
                                  }}
                                  className="btn-reset btn-border"
                                >
                                  <img
                                    src={editIcon}
                                    className="size"
                                    alt="edit-delete"
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    setNuggets((currentNugget) =>
                                      produce(currentNugget, (draft) => {
                                        draft[idx].nuggets.splice(ids, 1);
                                      })
                                    );
                                    setEditObj({ ...editObj, meditmode: true });
                                  }}
                                  className="btn-reset btn-border"
                                >
                                  <img
                                    src={deleteIcon}
                                    className="size"
                                    alt="edit-icon"
                                  />
                                </button>
                              </span>
                            </div>
                          </h3>
                          {!editObj.meditmode && (
                            <button
                              style={styles.enableDisable}
                              onClick={(event) => {
                                enableDisablePost(nenabled, nid, ids, idx);
                                event.stopPropagation();
                              }}
                            >
                              {nenabled
                                ? "Click to Disable"
                                : "Click to Enable"}
                            </button>
                          )}
                        </div>

                        <ul>
                          {objects.map((object, oidx) => (
                            <li
                              key={oidx + "asdfdfg"}
                              style={{
                                marginLeft: "10rem",
                                minHeight: "40px",
                                marginBottom: "1.5rem",
                              }}
                            >
                              <h3
                                className="edit-icons"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: ".5rem",
                                  fontSize: "1.5rem",
                                  textAlign: "justify",
                                  minHeight: "36px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    maxWidth: "90%",
                                  }}
                                >
                                  <span style={{ marginRight: "1rem" }}>
                                    {renderSwitch(object.otype)}
                                  </span>
                                  <span>
                                    {object.otitle.substring(0, 195) +
                                      `${
                                        object.otitle.length > 195 ? "..." : ""
                                      }`}
                                  </span>
                                </div>

                                <div className="hide__edit-icon">
                                  <span>
                                    {object.otype !== "Interactivity" && (
                                      <button
                                        onClick={() =>
                                          viewAddEditCurrentObject(
                                            object,
                                            idx,
                                            oidx,
                                            ids,
                                            nugget
                                          )
                                        }
                                        className="btn-reset btn-border"
                                      >
                                        <img
                                          src={eyeIcon}
                                          className="size"
                                          alt="edit-eye"
                                        />
                                      </button>
                                    )}
                                    {object.otype === "Interactivity" &&
                                      object.curl !== undefined && (
                                        <button
                                          onClick={() => {
                                            viewAddEditCurrentObject(
                                              object,
                                              idx,
                                              oidx,
                                              ids,
                                              nugget
                                            );
                                          }}
                                          className="btn-reset btn-border"
                                        >
                                          <img
                                            src={eyeIcon}
                                            className="size"
                                            alt="edit-eye"
                                          />
                                        </button>
                                      )}
                                    <button
                                      className="btn-reset btn-border"
                                      onClick={() => {
                                        if (object.otype == "quiz") {
                                          let crobj = { ...object };
                                          crobj.edit = true;
                                          //editObj.oeditmode = true;
                                          viewAddEditCurrentObject(
                                            crobj,
                                            idx,
                                            oidx,
                                            ids,
                                            nugget
                                          );
                                          // getQuiz(crobj);
                                        } else {
                                          editObj.oeditmode = true;
                                          viewAddEditCurrentObject(
                                            object,
                                            idx,
                                            oidx,
                                            ids,
                                            nugget
                                          );
                                        }
                                      }}
                                    >
                                      <img
                                        src={editIcon}
                                        className="size"
                                        alt="edit-delete"
                                      />
                                    </button>
                                    <button
                                      onClick={() => {
                                        setNuggets((currentNugget) =>
                                          produce(currentNugget, (draft) => {
                                            draft[idx].nuggets[
                                              ids
                                            ].objects.splice(oidx, 1);
                                          })
                                        );
                                        setEditObj({
                                          ...editObj,
                                          meditmode: true,
                                        });
                                      }}
                                      className="btn-reset btn-border"
                                    >
                                      <img
                                        src={deleteIcon}
                                        className="size"
                                        alt="edit-icon"
                                      />
                                    </button>
                                  </span>
                                </div>
                              </h3>
                            </li>
                          ))}
                        </ul>

                        <div
                          style={{
                            margin: "2rem 0 0 10rem",
                            height: "30px",
                          }}
                        >
                          <button
                            onClick={() => {
                              setcNugget({
                                nid,
                                ntitle,
                                objects,
                                ids,
                                idx,
                                cedit: true,
                              });
                              setObjOpen(true);
                            }}
                            style={styles.enableDisable}
                          >
                            Add object
                          </button>
                        </div>
                      </AccordionDetails>
                    </React.Fragment>
                  )
                )}
                <div style={{ margin: "1rem 3rem" }}>
                  <button
                    style={styles.enableDisable}
                    onClick={() => {
                      setNopen(true);
                      setType("Module");
                      setUnitIndex(idx);
                    }}
                  >
                    Add Module
                  </button>
                </div>
              </Accordion>
            ))}
            <div style={{ margin: "2rem 2rem" }}>
              <button
                style={styles.enableDisable}
                onClick={() => {
                  setNopen(true);
                  setType("Unit");
                }}
              >
                Add Unit
              </button>
            </div>
          </div>
        )}
        <div>
          {editObj.meditmode && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  swal({
                    title: "Are you sure?",
                    text: "Save the changes",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                  }).then((willsave) => {
                    if (willsave) {
                      // swal("Poof! Your imaginary file has been deleted!", {
                      //   icon: "success",
                      // });

                      validationcourse();
                    }
                  });
                }}
                style={{
                  backgroundColor: "rgb(227, 95, 20)",
                  color: "#fff",
                  width: "100px",
                  height: "36px",
                  marginRight: "10px",
                  alignSelf: "center",
                }}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                style={{ width: "100px", height: "36px", alignSelf: "center" }}
                onClick={() => {
                  swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                  }).then((willsave) => {
                    if (willsave) {
                      setIsLoading(true);
                      setCourseDetails({ ...mainCourse });
                      editObj.meditmode = false;
                      editObj.editbtn = true;
                      setEditObj({ ...editObj });
                      setIsLoading(false);
                      window.location.reload();
                    }
                  });
                }}
              >
                Discard
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
  const handleEventEditOpen = (type) => {
    setDialogOpen(true);
    setEditSessionData(type);
    setAddType("update");
    setEType("Edit");
  };
  const handleClose = () => {
    //getCourseDetails();
    setOpen(false);
    editObj.oeditmode = false;
    editObj.objectView = false;
    setEditObj({ ...editObj });
  };
  async function getEvents() {
    setLoading(true);
    let batchjson = [];
    batchjson.push(userDetails.curprgcou.bpid);

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        batchjson: batchjson,
        btid: userDetails.btid,
        rtype: "get",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const events = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_EVENTS,
        bodyParam
      );

      if (
        events !== undefined &&
        events.result !== undefined &&
        events.result.events.length > 0
      ) {
        if (events.result[userDetails.curprgcou.bpid] !== undefined)
          setEventData(events.result[userDetails.curprgcou.bpid]);
        setTableData(events.result.events);
      } else {
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  function tableview() {
    return tableData.length >= 1 ? (
      <TableBody>
        {(rowsPerPage > 0
          ? tableData.slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            )
          : tableData
        ).map((item, index) => {
          return (
            <TableRow>
              {/* <TableCell style={programetype}>
                {item.type.toUpperCase()} <br />
              </TableCell> */}
              {/* <TableCell style={programnames}>
                {moment(item.start).format("DD-MM-YYYY hh:mm a")}
              </TableCell> */}

              <TableCell style={programtype}>
                {item.title} <br />
                <div>
                  {" "}
                  {moment(item.start).format("DD-MM-YYYY hh:mm a")}
                  <br />
                  <a href={item.link} target="blank">
                    {item.link}{" "}
                  </a>
                </div>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <div
                  onClick={() => {
                    handleEventEditOpen(item);
                  }}
                >
                  <Edit className={Ann.icon} />
                </div>
              </TableCell>
              {/* <TableCell style={{ width: "10%" }}>
                <div
                  onClick={() => {
                    handleclickdelete(item, index);
                  }}
                >
                  <Delete className={Ann.icon} />
                </div>
              </TableCell> */}
            </TableRow>
          );
        })}
      </TableBody>
    ) : (
      <TableBody>
        <TableRow>
          <TableCell style={programnames}></TableCell>
          <TableCell style={programtype}>
            <p style={{ paddingLeft: "25%" }}>No Data</p>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }
  const panes = [
    {
      menuItem: "Course structure",
      render: () => (
        <Tab.Pane>
          <CourseStructure />
        </Tab.Pane>
      ),
    },

    {
      menuItem: "Assignment",
      render: () => (
        <Tab.Pane>
          <AssignmentAndAssessment
            courseId={lcourseDetails.btid}
            subject={courseDetails.ttitle}
            type="Assignment"
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Assessment",
      render: () => (
        <Tab.Pane>
          <AssignmentAndAssessment
            courseId={lcourseDetails.btid}
            subject={courseDetails.ttitle}
            type="Assessment"
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Recorded session",
      render: () => (
        <Tab.Pane>
          <RecordSession />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "References",
      render: () => (
        <Tab.Pane>
          <References />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Live Sessions",
      render: () => (
        <Tab.Pane>
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                className="add"
                onClick={() => {
                  setDialogOpen(true);
                  setAddType("put");
                  setEType("Add");
                }}
              >
                Add
              </button>
            </div>

            <div className={Ann.table}>
              {loading === false ? (
                <TableContainer component={Paper}>
                  <Table aria-label="custom pagination table">
                    {/* <TableHead style={{ background: config.main_color_1 }}>
                      <TableRow>
                        <TableCell style={header}>Event Type</TableCell>
                        <TableCell style={header}>Event Date & Time</TableCell>
                        <TableCell style={header}>Event Name</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead> */}
                    {loading ? "" : tableview()}
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: -1 },
                          ]}
                          colSpan={3}
                          count={tableData.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Skeleton variant="rect" width={1500} height={500} />{" "}
                </div>
              )}
            </div>
            <Dialog
              fullScreen={fullScreen}
              open={dialogOpen}
              onClose={handleLiveClose}
              className={classes.livepaper}
              aria-labelledby="responsive-dialog-titlecvvv"
              onBackdropClick="false"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2>{etype} Live Session</h2>
                <IconButton onClick={handleLiveClose}>
                  <Close />
                </IconButton>
              </div>
              <DialogContent>
                <LiveSession
                  coursetype="course"
                  liveSessionData={editsessiondata}
                  addtype={addtype}
                  eventid={deleteEventData}
                  handleClose={handleLiveClose}
                />
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
          </div>
        </Tab.Pane>
      ),
    },
  ];
  const handleTabChange = (aIndex) => {
    if (editObj.meditmode && aIndex != 0) {
      swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willsave) => {
        if (willsave) {
          setIsLoading(true);
          editObj.meditmode = false;
          editObj.editbtn = false;
          editObj.overViewEdit = false;
          setCourseDetails({ ...mainCourse });
          setEditObj({ ...editObj });
          setActiveIndex(aIndex);
          setIsLoading(false);
          window.location.reload();
        } else {
          setActiveIndex(0);
          setCourseDetails({ ...courseDetails });
        }
      });
    } else if (!editObj.meditmode) {
      if (aIndex == 0) {
        setEditObj({ ...editObj, editbtn: true });
        setNuggets(mainCourse.unit);
        setCourseDetails({ ...mainCourse });
      } else {
        setOpen(false);
        editObj.oeditmode = false;
        editObj.editbtn = false;
        setEditObj({ ...editObj });
      }

      setActiveIndex(aIndex);
    } else {
      setActiveIndex(0);
      setCourseDetails({ ...courseDetails });
    }
  };
  const changeHandler = (event) => {
    if (event.target.files == null) {
      return;
    }
    if (event.target.files[0].size > 5242880) {
      swal(
        "Oops!",
        "Image size is too large. File size cannot be greater than 5mb.",
        "error"
      );
      return;
    }
    if (event.target.files[0] !== undefined) {
      refselectedCourseFile.current = event.target.files[0];
      //setSelectedCourseFile((currentState) => (event.target.files[0]));
      var body = {
        filetype: event.target.files[0].type,
        filename: "topic.png",
        folder: courseDetails.tid,
      };

      uploadfile(body);
    }
  };
  async function uploadfile(body) {
    setIstLoading(true);
    console.log(JSON.stringify(body, null, 2));
    const bodyParam = {
      body,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const preSignedData = await API.post(
        config.aws_cloud_logic_custom_name,
        //Constants.GET_PRESIGNED_URL,
        "/getpreSignedURL",
        bodyParam
      );

      axios
        .put(preSignedData, refselectedCourseFile.current, {
          headers: {
            "Content-Type": refselectedCourseFile.current.type,
            "Cache-Control": "no-cache no-store must-revalidate",
          },
        })
        .then((response) => {
          console.log("file upload success");
          setEditObj({ ...editObj, topicimgchanges: true, meditmode: true });
          // setEditObj({ ...editObj, meditmode: true });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
      setIstLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  function breadcrumb() {
    let sdata = { ...userDetails };
    let temp = [...sdata.breadcrumb];

    temp[3] = {
      name: "Course View",
      path: "/applicationdetails",
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));
  }
  const handleLiveClose = () => {
    setDialogOpen(false);
  };
  const [scroll, setScroll] = React.useState("paper");
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  return (
    <main ref={scrollRef}>
      {/* <pre> {JSON.stringify(user, null, 2)}</pre> */}

      <div
        className="btn-toggle"
        onClick={() => handleToggleSidebar(true)}
      ></div>
      <UserHeader Bindex={3} />
      <ObjectPopUp
        objOpen={objOpen}
        setObjOpen={setObjOpen}
        renderSwitch={renderSwitch}
        folder={folder}
        cNugget={cNugget}
        setNuggets={setNuggets}
        nuggets={nuggets}
        setEditObj={setEditObj}
        editObj={editObj}
      />
      {editObj.objectView && (
        <Dialog
          open={open}
          onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          onBackdropClick="false"
          className={classes.paper}
          fullScreen={fullScreen}
        >
          <DialogContent>
            <CoursePlayer
              handleClose={handleClose}
              courseDetails={courseDetails}
              setCourseDetails={setCourseDetails}
              objectData={objectData}
              setObjectData={setObjectData}
              oIndex={oIndex}
              setOIndex={setOIndex}
              curObject={curObject}
              setcurObject={setcurObject}
              curObRef={curObRef}
              assignment={assignment}
              setAssignment={setAssignment}
              summative={summative}
              setSummative={setSummative}
              sumScore={sumScore}
              setSumScore={setSumScore}
              miniScore={miniScore}
              setMiniScore={setMiniScore}
              sMiniScore={sMiniScore}
              setSMiniScore={setSMiniScore}
              qisLoading={qisLoading}
              setQIsLoading={setQIsLoading}
              editObj={editObj}
              setEditObj={setEditObj}
              assignmentLoad={assignmentLoad}
              setAssignmentLoad={setAssignmentLoad}
              renderSwitch={renderSwitch}
              setSelectedObj={setSelectedObj}
              selectedObj={selectedObj}
              setNuggets={setNuggets}
              nuggets={nuggets}
              folder={courseDetails.tid}
              setOpen={setOpen}
              open={open}
            />
          </DialogContent>
        </Dialog>
      )}

      <div className={Cviewstyle.management}></div>
      <div className={Cviewstyle.management_info}>
        <div className={Cviewstyle.h1} style={{ display: "flex" }}>
          <h1
            style={{ color: "black", fontSize: "20px", maxWidth: "66%" }}
            className="title-hover"
          >
            <>
              {!editObj.titleEdit && (
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  {courseDetails.ttitle}{" "}
                  <span
                    className="hide_edit-title"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "-60px",
                    }}
                  >
                    <button
                      onClick={() => {
                        setEditObj({ ...editObj, titleEdit: true });
                      }}
                      className="btn-reset btn-border"
                    >
                      <img src={editIcon} className="size" alt="edit-delete" />
                    </button>
                  </span>
                </strong>
              )}
              {editObj.titleEdit && (
                <strong style={{ display: "flex", alignItems: "center" }}>
                  <TextareaAutosize
                    maxRows={3}
                    cols={200}
                    aria-label="maximum height"
                    placeholder=""
                    defaultValue={courseDetails.ttitle}
                    style={{
                      width: "100%",
                      fontSize: "18px",
                      padding: "1rem",
                      resize: "none",
                    }}
                    onChange={(e) => {
                      // topicData.tdescription = e.target.value;
                      setCourseDetails((prevcourseDetails) =>
                        produce(prevcourseDetails, (v) => {
                          v.ttitle = e.target.value;
                        })
                      );
                      setEditObj({ ...editObj, meditmode: true });
                    }}
                  />
                  <span>
                    <button
                      onClick={() => {
                        setEditObj({ ...editObj, titleEdit: false });
                      }}
                      className="btn-reset btn-border"
                    >
                      <CloseIcon
                        className="size"
                        style={{
                          fontSize: "2rem !important",
                          color: "#19478a",
                          fill: "#19478a",
                        }}
                      />
                    </button>
                  </span>
                </strong>
              )}
            </>
          </h1>
          {/* {!isLoading && editObj.editbtn && (
            <button
              style={styles.editButton}
              onClick={() => {
                editObj.meditmode = true;
                editObj.editbtn = false;
                setEditObj({ ...editObj });
              }}
            >
              {" "}
              Edit course
            </button>
          )} */}
        </div>
        <div
          style={{ marginBottom: "2rem", fontWeight: "bold" }}
          className="semester-hover"
        >
          {editObj.editSemester ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <select
                onChange={(e) => {
                  setCourseDetails((prevcourseDetails) =>
                    produce(prevcourseDetails, (v) => {
                      v.semester = e.target.value;
                    })
                  );
                  setEditObj({ ...editObj, meditmode: true });
                }}
                style={{ width: "250px", padding: ".5rem", fontSize: "1.4rem" }}
                defaultValue={courseDetails.semester}
              >
                {[
                  {
                    sem: "----Select Semester----",
                    value: 0,
                    disabled: true,
                  },
                  {
                    sem: "Semester 1",
                    value: 1,
                  },
                  {
                    sem: "Semester 2",
                    value: 2,
                  },
                  {
                    sem: "Semester 3",
                    value: 3,
                  },
                  {
                    sem: "Semester 4",
                    value: 4,
                  },
                  {
                    sem: "Semester 5",
                    value: 5,
                  },
                  {
                    sem: "Semester 6",
                    value: 6,
                  },
                  {
                    sem: "Semester 7",
                    value: 7,
                  },
                  {
                    sem: "Semester 8",
                    value: 8,
                  },
                ].map((semester) => (
                  <option
                    style={{ fontSize: "1.4rem" }}
                    key={semester.value}
                    value={semester.value}
                    disabled={semester.disabled}
                  >
                    {semester.sem}
                  </option>
                ))}
              </select>
              <input
                defaultValue={courseDetails.coursenum}
                value={courseDetails.coursenum}
                placeholder="Enter course label..."
                pattern="\d*"
                maxLength="4"
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    let coursenum = e.target.value;
                    setCourseDetails((prevtopicData) =>
                      produce(prevtopicData, (v) => {
                        v.coursenum = coursenum;
                      })
                    );
                    setEditObj({ ...editObj, meditmode: true });
                  }
                }}
                style={{
                  width: "250px",
                  padding: ".5rem",
                  fontSize: "1.4rem",
                  marginLeft: "1rem",
                }}
              />
              <button
                onClick={() => {
                  setEditObj({ ...editObj, editSemester: false });
                }}
                className="btn-reset btn-border"
              >
                <CloseIcon
                  className="size"
                  style={{
                    fontSize: "2rem !important",
                    color: "#19478a",
                    fill: "#19478a",
                  }}
                />
              </button>
            </div>
          ) : (
            <div
              className="semester-hover"
              style={{ display: "flex", alignItems: "center" }}
            >
              {courseDetails.semester == undefined ||
              courseDetails.coursenum == undefined ? (
                "Edit Semester & Course number"
              ) : (
                <h3>
                  {courseDetails.semester &&
                    courseDetails.tlabel &&
                    courseDetails.coursenum &&
                    `${courseDetails.tlabel}`}
                </h3>
              )}

              <span className="semester-edit">
                <button
                  onClick={() => {
                    setEditObj({ ...editObj, editSemester: true });
                  }}
                  className="btn-reset btn-border"
                >
                  <img src={editIcon} className="size" alt="semester-edit" />
                </button>
              </span>
            </div>
          )}
        </div>
        <div className={Cviewstyle.flex_box}>
          <div className={Cviewstyle.flex_box__container}>
            <div className={Cviewstyle.time_line}>
              <div className="week-hover" style={{ display: "flex" }}>
                <>
                  {!editObj.weekEdit && (
                    <div
                      className="week-border"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>
                        <ClockGray
                          className="clock-size"
                          cls1="cls1"
                          cls2="cls2"
                        />
                      </span>
                      <span
                        style={{
                          fontSize: "15px",
                          marginBottom: ".5rem",
                          marginRight: ".5rem",
                        }}
                      >
                        {courseDetails.tduration} weeks
                      </span>
                    </div>
                  )}
                </>
                <span className="hide__edit-week">
                  <button
                    onClick={() => {
                      setEditObj({ ...editObj, weekEdit: true });
                    }}
                    className="btn-reset btn-border"
                  >
                    <img src={editIcon} className="size" alt="edit-edit" />
                  </button>
                </span>
              </div>
            </div>

            {editObj.weekEdit && (
              <div
                style={{
                  width: "170px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <RegexTextField
                  regex={onlyAlphanumericRegex}
                  label="Weeks"
                  defaultValue={courseDetails.tduration}
                  onChange={(e) => {
                    courseDetails.tduration = e.target.value;
                    setCourseDetails((prevcourseDetails) => ({
                      ...prevcourseDetails,
                      ...courseDetails,
                    }));
                    setEditObj({ ...editObj, meditmode: true });
                  }}
                />
                <span
                // className="hide__edit-week"
                >
                  <button
                    onClick={() => {
                      setEditObj({ ...editObj, weekEdit: false });
                    }}
                    className="btn-reset btn-border"
                  >
                    <CloseIcon
                      className="size"
                      style={{
                        fontSize: "2rem !important",
                        color: "#19478a",
                        fill: "#19478a",
                      }}
                    />
                  </button>
                </span>
              </div>
            )}

            <div>
              {editObj.overViewEdit && (
                <div className="discc-border" style={{ position: "relative" }}>
                  <TextareaAutosize
                    maxRows={10}
                    aria-label="maximum height"
                    placeholder=""
                    defaultValue={courseDetails.tdescription}
                    style={{
                      width: "100%",
                      fontSize: "18px",
                      padding: "1rem",
                      resize: "none",
                    }}
                    onChange={(e) => {
                      // topicData.tdescription = e.target.value;

                      setCourseDetails((prevcourseDetails) =>
                        produce(prevcourseDetails, (v) => {
                          v.tdescription = e.target.value;
                        })
                      );
                      setEditObj({ ...editObj, meditmode: true });
                    }}
                  />
                  <span
                    className="hide__edit-wise"
                    style={{
                      position: "absolute",
                      top: "-3.3rem",
                      right: "-13px",
                    }}
                  >
                    <button
                      onClick={() => {
                        setEditObj({ ...editObj, overViewEdit: false });
                      }}
                      className="btn-reset btn-border"
                    >
                      <CloseIcon
                        className="size"
                        style={{
                          fontSize: "2rem !important",
                          color: "#19478a",
                          fill: "#19478a",
                        }}
                      />
                    </button>
                  </span>
                </div>
              )}
              {!editObj.overViewEdit && (
                <div className="disc-border" style={{ position: "relative" }}>
                  <p
                    style={{ fontSize: "15px" }}
                    dangerouslySetInnerHTML={{
                      __html: courseDetails.tdescription,
                    }}
                  ></p>
                  <span
                    className="hide__edit-disc"
                    style={{
                      position: "absolute",
                      top: "-2.8rem",
                      right: "-13px",
                    }}
                  >
                    <button
                      onClick={() => {
                        setEditObj({ ...editObj, overViewEdit: true });
                      }}
                      className="btn-reset btn-border"
                    >
                      <img src={editIcon} className="size" alt="edit-edit" />
                    </button>
                  </span>
                </div>
              )}
            </div>
          </div>
          <div
            className={Cviewstyle.management__image}
            style={{
              position: "relative",
              height: "290px",
              borderRadius: "10px",
            }}
          >
            {(!editObj.imgEdit ||
              refselectedCourseFile.current === undefined) &&
              !isLoading && (
                <span
                  className="image-hover"
                  style={{ display: "flex", position: "relative" }}
                >
                  <img
                    src={courseDetails.topicimg}
                    className={Caviewstyle.eimagebox}
                    alt="Courseimage"
                  />
                  {editObj.imgEdit ? (
                    <span
                      className="hide_image-icon"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "0",
                        right: "-10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setEditObj({ ...editObj, imgEdit: false });
                        }}
                        className="btn-reset btn-border"
                      >
                        <CloseIcon
                          className="size"
                          style={{
                            fontSize: "1.8rem !important",
                            color: "#19478a",
                            fill: "#19478a",
                          }}
                        />
                      </button>
                    </span>
                  ) : (
                    <span
                      className="hide_image-icon"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "-10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setEditObj({ ...editObj, imgEdit: true });
                        }}
                        className="btn-reset btn-border"
                      >
                        <img className="size" src={editIcon} alt="editImage" />
                      </button>
                    </span>
                  )}
                </span>
              )}
            {isLoading ? <Skeleton variant="rect" height={210} /> : null}
            {editObj.imgEdit && (
              <>
                {refselectedCourseFile.current !== undefined && (
                  <img
                    className={Caviewstyle.eimagebox}
                    src={URL.createObjectURL(refselectedCourseFile.current)}
                    alt="topicimage"
                  />
                )}

                <input
                  type="file"
                  id="cfiles"
                  style={{ visibility: "hidden", position: "absolute" }}
                  onChange={changeHandler}
                  accept="Image/*"
                />
                <label
                  for="cfiles"
                  style={{
                    position: "absolute",
                    right: "10px",
                    bottom: "6px",
                  }}
                >
                  <AddAPhotoIcon
                    style={{ color: "#19478a", cursor: "pointer" }}
                  />
                </label>
              </>
            )}
          </div>
        </div>
      </div>
      <Tab
        panes={panes}
        onTabChange={(e, { activeIndex }) => handleTabChange(activeIndex)}
        activeIndex={activeIndex}
      />
    </main>
  );
}
let styles = {
  editButton: {
    color: "white",
    borderStyle: "groove ",
    borderColor: config.main_color_2,
    height: "30px ",
    lineHeight: "0px ",
    width: "150px",
    marginTop: "15px",
    marginRight: "50px",
    backgroundColor: config.main_color_2,
    fontSize: "15px ",
    borderRadius: "3px ",
    float: "right",
    fontWeight: "bold",
  },
  enableDisable: {
    color: "#f18121",
    border: "1px solid #f18121",
    backgroundColor: "white",
    fontSize: "15px ",
    borderRadius: "3px ",
    padding: ".3rem 2rem",
    alignSelf: "center",
    fontWeight: "bold",
  },
};
